export function getPlatformApiUrl(url: string, version: string = 'v1') {
  return `/nebulith-user/${version}/${url}`.replaceAll('//', '/');
}

/** nebulith-user 服务 API 前缀 */
export function getNebulithUserApiUrl(url: string, version: string = 'v1') {
  return `/nebulith-user/${version}/${url}`.replaceAll('//', '/');
}

export const getPlatformTrainApiUrl = (url: string, version: string = 'v1') => {
  return `/nebulith-user/${version}/${url}`.replaceAll('//', '/');
};

export const getPlatformBaseApiUrl = (url: string, version: string = 'v1') => {
  return `/nebulith-user/${version}/${url}`.replaceAll('//', '/');
};

export const getPlatformExploreApiUrl = (
  url: string,
  version: string = 'v1',
) => {
  return `/nebulith-user/${version}/${url}`.replaceAll('//', '/');
};

/** nebulith-admin 服务 API 前缀 */
export function getAdminApiUrl(url: string, version: string = 'v1') {
  return `/nebulith-admin/${version}/${url}`.replaceAll('//', '/');
}

/** nebulith-inference-pro 服务 API 前缀 */
export function getNebulithInferenceProApiUrl(
  url: string,
  version: string = 'v1',
) {
  return `/nebulith-inference-pro/${version}/${url}`.replaceAll('//', '/');
}

/** 原网关 API 路径 */
export function getSpiritxApiPath(url: string, version: string = 'v1') {
  return `spiritx-api/${version}/${url}`.replaceAll('//', '/');
}

/**
 * 平台网关代理地址：inference-pro 转发原 spiritx-api
 * 例：/nebulith-inference-pro/v1/gateway/proxy/spiritx-api/v1/token-usage/list-details-page
 */
export function getNebulithGatewayApiUrl(
  url: string,
  version: string = 'v1',
  gatewayApiVersion: string = 'v1',
) {
  return getNebulithInferenceProApiUrl(
    `gateway/proxy/${getSpiritxApiPath(url, gatewayApiVersion)}`,
    version,
  );
}

/** 是否为平台网关代理请求 */
export function isGatewayProxyApiUrl(url?: string) {
  return Boolean(url && url.includes('/gateway/proxy/spiritx-api/'));
}

/** nebulith-storage 服务 API 前缀 */
export function getStorageApiUrl(url: string, version: string = 'v1') {
  return `/nebulith-storage/${version}/${url}`.replaceAll('//', '/');
}

/** nebulith-notification 服务 API 前缀 */
export function getNotificationApiUrl(url: string, version: string = 'v1') {
  return `/nebulith-notification/${version}/${url}`.replaceAll('//', '/');
}
